import React, { useState } from "react"
import { Box, Button, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Layout } from "src/components/layout"
import InputTextField from "src/components/atom/InputTextField"
import { useAuth } from "src/providers/LoginProvider"

import "./index.scss"
import { UserService } from "src/openapi"
import { ShowToast } from "../../states/showToast"
import { ShowProgress } from "../../states/showProgress"
import { useRecoilState } from "recoil"
import BreadCrumb from "src/components/atom/BreadCrumb"
import { Top } from "../top"
import { SIDE_MENU, SNACKBAR_TYPES } from "src/modules/const"

export const PasswordUpdate = () => {
  const { t } = useTranslation("translation", { keyPrefix: "password" })

  const [password, setPassword] = useState<string>("")
  const [confirmPassword, setConfirmPassword] = useState<string>("")
  const [validation, setValidation] = useState<boolean>(false)

  const { user } = useAuth()

  const [, setShowToast] = useRecoilState(ShowToast)
  const [, setShowProgress] = useRecoilState(ShowProgress)

  const [passwordValidationMessage, setPasswordValidationMessage] = useState<string>("")
  const [passwordConfirmValidationMessage, setPasswordConfirmValidationMessage] =
    useState<string>("")

  const checkValidation = async () => {
    let valid = true

    if (password == "" || confirmPassword == "") {
      valid = valid && false
      setPasswordConfirmValidationMessage("")
    } else {
      if (password != confirmPassword) {
        valid = valid && false
        setPasswordConfirmValidationMessage(t("password_password_confirm_different"))
      } else {
        if (password.length < 6) {
          setPasswordConfirmValidationMessage(t("password_length_min"))
        } else {
          setPasswordValidationMessage("")
          setPasswordConfirmValidationMessage("")
        }
      }
    }

    setValidation(valid)
  }

  const handleUpdatePassword = () => {
    if (!user) {
      return
    }
    setShowProgress(true)

    UserService.updateUserPassword(
      user.companyID,
      user.id,
      {
        password: password,
      },
      user.token
    )
      .then(() => {
        setShowProgress(false)
        setShowToast({
          show: true,
          text: t("success_change_password"),
          type: SNACKBAR_TYPES.SUCCESS,
        })
      })
      .catch(() => {
        setShowProgress(false)
        setShowToast({ show: true, text: t("failed_change_password"), type: SNACKBAR_TYPES.ERROR })
      })
  }

  if (!user) {
    return <Top />
  }

  return (
    <Layout menu={SIDE_MENU.PASSWORD_CHANGE}>
      <BreadCrumb
        paths={[
          {
            name: t("title"),
            link: "",
          },
        ]}
      />
      <Typography className="password-update-description">{t("password_description")}</Typography>
      <Box className="password-content-container">
        <Box className="password-item-container">
          <Box className="password-item-title required">{t("new_password")}</Box>
          <Box className="password-item-content-container">
            <InputTextField
              text={password}
              handleText={setPassword}
              inputStyle={{ width: "300px", height: "54px" }}
              placeholder={t("new_password")}
              password
              checkValidation={checkValidation}
              validationMessage={passwordValidationMessage}
            />
          </Box>
        </Box>
        <Box className="password-item-container">
          <Box className="password-item-title required">{t("confirm_password")}</Box>
          <Box className="password-item-content-container">
            <InputTextField
              text={confirmPassword}
              handleText={setConfirmPassword}
              inputStyle={{ width: "300px", height: "54px" }}
              placeholder={t("confirm_password")}
              password
              checkValidation={checkValidation}
              validationMessage={passwordConfirmValidationMessage}
            />
          </Box>
        </Box>
      </Box>
      <Button
        className="employee-update-save-button"
        sx={{
          ...(!validation
            ? { backgroundColor: "#F3F3F3 !important", color: "#B9B9B9 !important" }
            : {}),
          width: "200px!important",
        }}
        disabled={!validation}
        onClick={() => handleUpdatePassword()}
      >
        {t("change")}
      </Button>
    </Layout>
  )
}
